import { gql } from '@apollo/client';

export type ALL_USER_ASSIGNED_METABASE_DASHBOARDSType = {
  data: {
    id: string;
    metabaseId: number;
    metabaseName: string;
    user: {
      id: string;
    };
  }[];
};

export const ALL_USER_ASSIGNED_METABASE_DASHBOARDS = gql`
  query GetUserMetabaseDashboards {
    data: getUserMetabaseDashboards {
      id
      metabaseId
      metabaseName
      user {
        id
      }
    }
  }
`;
